export {
  InputArea,
  type InputAreaProps,
} from '../../compositions/shared/InputArea';
